import React from 'react';
import InvisibleToInvincibleSlider from './InvisibleToInvincibleSlider';

const InvisibleToInvincible = () => {
  return (
    <div className="bg-white">
      <div className="container py-[48px]">
        <div className="flex flex-col justify-center items-center h-full gap-[48px] ">
          <h2
            className={
              'flex flex-col md:text-center justify-center items-center w-full font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px]'
            }
          >
            <span>From Invisible to Invincible:</span>

            <span className="hidden md:block"> Your Organic SEO Transformation Begins Here!</span>
          </h2>

          <InvisibleToInvincibleSlider />
        </div>
      </div>
    </div>
  );
};

export default InvisibleToInvincible;
